import React, { Component } from 'react';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

let me;

class Productos extends Component {
    constructor(props) {
        super(props);
        me = this;
        this.selectComboProducto = this.selectComboProducto.bind(this);
    }

    selectComboProducto(event) {

        me.props.selectComboProducto(event.target.value);
    }

    render() {
        let { productos } = me.props.data;
        let productoSeleccionado = productos.find(x => x.seleccionado);
        let codigo = productoSeleccionado != undefined ? productoSeleccionado.CODIGO_PRODUCTO : "";

        let productosNodes = productos.map((producto, index) => {
            const isWhiteRow = index % 2 == 0;
            const rowClass = isWhiteRow
                ? 'atlas_seccionGrilla__registro--registroBlanco'
                : 'atlas_seccionGrilla__registro--registroGris';

            return (
                <GenericOption
                    key={"PRODUCTO_" + producto.CODIGO_PRODUCTO}
                    id={producto.CODIGO_PRODUCTO}
                    description={producto.CODIGO_PRODUCTO}
                    isWhiteRow={isWhiteRow}
                    rowClass={rowClass}
                />
            );
        });

        return (
            <div className="row top-separator-xs bottom-separator-xs">
                <div className="col-xs-2 top-separator-xxs">
                    <label className="label-primary">Producto para filtrar.</label>
                </div>
                <div className="col-xs-10">
                    <GenericSelect
                        id="productosSelect"
                        className="form-control default-select"
                        options={productosNodes}
                        value={codigo}
                        onChange={me.selectComboProducto}
                    />
                </div>
            </div>
        );
    }
};

export default Productos;